import { Benefit } from 'generated/apolloComponents'
import {
  ReactChild,
  ReactFragment,
  ReactNode,
  ReactPortal,
  useState,
} from 'react'
import useTranslation from 'next-translate/useTranslation'
import styles from './BenefitsList.module.scss'
import {
  BenefitsIcon,
  PerksIcon,
  RelocationIcon,
} from '../atoms/JobBoardIcons/JobBoardIcons'

interface IProps {
  benefits: Benefit[]
  categories: string[]
  icon?: ReactNode
  title: string
  color?: string | undefined
  type: 'benefits' | 'perks' | 'relocation'
  [key: string]: any
}

const BenefitsList = ({
  benefits,
  categories,
  icon,
  type,
  title,
  color,
  ...rest
}: IProps) => {
  if (!benefits) return null
  const { t } = useTranslation()

  const [filteredCategory, setFilteredCategory] = useState(
    benefits.filter((item) => categories.includes(item.category as string))
  )

  return (
    <>
      {filteredCategory.length !== 0 ? (
        <div {...rest}>
          <header className='flex items-center md:mb-6'>
            <div className={styles.benefits__icon}>
              {type === 'benefits' ? <BenefitsIcon color={color} /> : null}
              {type === 'relocation' ? (
                <RelocationIcon width={40} height={40} color={color} />
              ) : null}
              {type === 'perks' ? <PerksIcon color={color} /> : null}
            </div>
            <p className='text-c22'>{title}</p>
          </header>
          <ul className={styles.benefits__data}>
            {filteredCategory.map((item, index) => (
              <li key={index} className='font-normal my-4'>
                {item.owner
                  ? item.localizedName
                  : t(`benefit:${item.category}.${item.name}`)}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </>
  )
}

export default BenefitsList
